import type { TFunction } from 'i18next';

type RolePresentation = { name?: string; description?: string; isSystemRole: boolean };

// Match only unchanged seed defaults. Stored text is never an arbitrary locale key.
const NAME_KEYS: Readonly<Record<string, string>> = {
  最高管理員: 'builtinRoleSuperAdminName',
  場管: 'builtinRoleFloorName',
  荷官: 'builtinRoleDealerName',
  櫃台: 'builtinRoleCashierName',
};
const DESCRIPTION_KEYS: Readonly<Record<string, string>> = {
  '擁有所有系統權限，可管理角色、使用者與系統設定': 'builtinRoleSuperAdminDescription',
  '負責現場管理、賽事控制與計時器操作': 'builtinRoleFloorDescription',
  '負責桌面操作，記錄淘汰、Rebuy、Addon（使用 Dealer PWA，無需 web 側邊欄權限）':
    'builtinRoleDealerDescription',
  '負責會員報到、收費、帳務登記與獎金發放': 'builtinRoleCashierDescription',
};

function displayField(
  value: string | undefined,
  isSystemRole: boolean,
  keys: Readonly<Record<string, string>>,
  t: TFunction,
): string | undefined {
  if (!isSystemRole || value === undefined || !Object.hasOwn(keys, value)) return value;
  return t(keys[value]!, { ns: 'admin', defaultValue: value });
}

export function roleDisplayName(role: RolePresentation & { name: string }, t: TFunction): string {
  return displayField(role.name, role.isSystemRole, NAME_KEYS, t)!;
}

export function roleDisplayDescription(role: RolePresentation, t: TFunction): string | undefined {
  return displayField(role.description, role.isSystemRole, DESCRIPTION_KEYS, t);
}
